// Generated by scripts/update-seeq-icons.js from src/svg/seeq/displays.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcDisplays = {
  prefix: 'fak',
  iconName: 'displays' as IconName,
  icon: [
    1152,
    1024,
    [],
    'e98c',
    'M1056 0h-960c-53 0-96 43-96 96v0 640c0 53 43 96 96 96v0h384l-32 96h-144c-26.5 0-48 21.5-48 48s21.5 48 48 48v0h544c26.5 0 48-21.5 48-48s-21.5-48-48-48v0h-144l-32-96h384c53 0 96-43 96-96v0-640c0-53-43-96-96-96v0zM128 675.7v-175.4c5.8 3.1 12.8 5 20.2 5 2.5 0 5-0.2 7.4-0.6l-0.3 0c13.6-2.8 22.6-11.2 31.7-19.6l108.6-207.3 122.1 257.8c4.5 14 22.6 22.4 45.3 22.4s40.7-5.6 49.7-19.6l108.6-154.2 117.7 266.3c4.5 11.2 22.6 22.4 40.7 25.2zM1024 675.7h-235.3c18 0 36.2-5.6 45.3-14l117.6-126 40.7 44.8c9.1 8.4 31.7 5.6 31.7-5.6zM1024 502c0-8.4-4.5-14-9-22.4l-13.6-25.2c-9.1-8.4-27.1-16.8-45.3-16.8s-36.2 5.6-45.2 14l-104 106.5-126.8-280.3c-4.5-14-22.6-22.4-45.2-22.5s-40.7 5.6-49.8 19.7l-108.6 156.9-126.6-271.9c-4.5-14-27.1-22.4-49.8-22.4s-40.7 8.4-49.8 22.4l-122.3 230v-262h896z',
  ],
} satisfies IconDefinition;
